import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';

const categories = [
  'Professional services',
  'Industrial & manufacturing',
  'Suppliers & distributors',
  'Logistics',
  'Local & service businesses',
  'Training & education',
] as const;

export function GoodFitSection() {
  return (
    <section className="section good-fit">
      <div className="shell">
        <Reveal><SectionHeading
          eyebrow="Good Fit For"
          title="Business websites with a clear commercial job to do."
          text="The studio is a strong fit when the website needs to explain an offer, organize business information, support enquiries, or move a customer toward the next step."
        /></Reveal>
        <Reveal><ul className="good-fit__grid">
          {categories.map((category) => (
            <li key={category}><strong>{category}</strong></li>
          ))}
        </ul></Reveal>
      </div>
    </section>
  );
}
